export default (props, vars) =>
  !!vars?.['useapplicationsstatus2']?.['applicationStatus'];
